// @ts-strict-ignore
import invoke from 'lodash/invoke';
import isEmpty from 'lodash/isEmpty';

import log from '~/helpers/logging';

import type { Props } from './NotesModal';


export function determineIfNotesModalShouldBeOpen(
  addingNoteTo: Props['addingNoteTo'],
  isNotesModalOpen: Props['isNotesModalOpen'],
  trigger: Props['trigger'],
) {
  if (isNotesModalOpen === undefined) {
    return (!trigger ? Boolean(addingNoteTo) : false);
  }

  return isNotesModalOpen;
}

export function handleToggleModal(event, setState, state, toggleModal) {
  if (toggleModal) {
    toggleModal(!state.isNotesModalOpen);
  } else {
    setState(currentState => ({
      ...currentState,
      isNotesModalOpen: !currentState.isNotesModalOpen,
    }));
  }
}

export function handleNoteInput(event, setState) {
  const note = event.target.value;

  setState(currentState => ({
    ...currentState,
    note,
    isButtonDisabled: !note.length,
  }));
}

export function handleNoteFormSubmit(
  event,
  ajaxRequest,
  applicationType,
  onAddNote,
  setState,
  state,
  toggleModal,
  options,
) {
  event.preventDefault();

  setState(currentState => ({
    ...currentState,
    isButtonDisabled: true,
    isSubmitting: true,
  }));

  ajaxRequest(state.note).then(data => {
    setState(currentState => ({
      ...currentState,
      isButtonDisabled: false,
      isSubmitting: false,
    }));

    toggleModal();

    if (isEmpty(data)) { return null; }
    if (data.result === 'error') {
      return invoke(
        options,
        'createMessage',
        `${data.message ?? 'Something went wrong.'} Please try again or contact support.`,
        'warning',
      );
    }

    if (data.message) {
      invoke(options, 'createMessage', data.message, 'success');
    }

    if (data.result === 'success' || data.created_at) {
      if (options.getState) { return options.getState(); }
      if (onAddNote) {
        setState(currentState => ({ ...currentState, note: '' }));

        return onAddNote(data.data);
      }

      if (!data.message) {
        invoke(options, 'createMessage', 'Note added successfully', 'success');
      }
      return setTimeout(() => { window.location.reload(); }, 1500);
    }

    return null;
  }).catch(exception => {
    log('error', `POST ${applicationType} notes exception`, {}, exception);
    invoke(options, 'onError', exception);

    return setTimeout(() => { window.location.reload(); }, 1500);
  });
}

export function onClose(event, setState) {
  setState(currentState => ({ ...currentState, isNotesModalOpen: false }));
}
